import clsx from 'clsx';
import { CarManagementTool } from './retailCarManagementTool/carManagementTool';

export const SliderCar = ({
  carInfo,
  active,
  driversList = [],
  deliveryInfo,
  handleClickAction,
  hasOnlyDriversRole,
  deliveryInfoLoading,
}) => {

  const { cncode } = carInfo;

  return (
    <div
      className={clsx(
        'flex flex-col justify-center items-center mt-8 w-full',
        active && !cncode && !hasOnlyDriversRole && 'max-lg:mb-16'
      )}
    >
      <div
        className={clsx(
          'w-full aspect-[16/9] lg:w-[550px] 2xl:w-[750px] lg:pt-20 xl:pt-16',
          !active && 'opacity-20'
        )}
        title={carInfo?.carTitle}
      >
        <img
          alt={carInfo?.carTitle}
          src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${
            carInfo?.MakeName ?? carInfo?.carTitle?.split(' ')[0]
          }&modelFamily=${
            carInfo?.ModelName === carInfo?.carTitle?.split(' ')[0]
              ? carInfo?.carTitle?.split(' ')[1]
              : carInfo?.ModelName
          }&modelVariant=${carInfo?.ModelName}&modelYear=${
            carInfo?.ModelYear
          }&powerTrain=hybrid&trim=eu&zoomType=fullScreen&width=800&angle=28`}
        />
      </div>   
      {carInfo && active && <CarManagementTool 
        driversList={driversList}
        deliveryInfo={deliveryInfo}
        deliveryInfoLoading={deliveryInfoLoading}
        carInfo={carInfo}
        key={`management-tool-${carInfo?.plateno || carInfo?.cncode}`}
        hasOnlyDriversRole={hasOnlyDriversRole}
        handleClickAction={handleClickAction}
      />}
      {active && carInfo?.plateno && (
        <div className="text-center pt-6 justify-between max-lg:grid max-lg:grid-cols-2 max-lg:gap-3 lg:border-t lg:border-[#A5A5A5] lg:flex lg:w-[70vw] lg:mt-24 xl:mt-28 2xl:-mt-4">
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Κατασκευαστής/ Μοντέλο</p>
            <p className="text-body">
              {carInfo?.MakeName} {carInfo?.ModelName}
            </p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Αριθμός Πινακίδας</p>
            <p className="text-body">{carInfo?.plateno}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Τύπος Καυσίμου</p>
            <p className="text-body">{carInfo?.FuelType}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Τύπος Αυτοκινήτου</p>
            <p className="text-body">{carInfo?.BodyType}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Πρώτη Άδεια Κυκλοφορίας</p>
            <p className="text-body">{carInfo?.FirstLicenseDate?.split('-')[2] + '/' +carInfo?.FirstLicenseDate?.split('-')[1] + '/' + carInfo?.FirstLicenseDate?.split('-')[0]}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Έναρξη Συμβολαίου</p>
            <p className="text-body">{carInfo?.StartDate?.split('-')[2] + '/' +carInfo?.StartDate?.split('-')[1] + '/' + carInfo?.StartDate?.split('-')[0]}</p>
          </div>
          <div className="max-lg:bg-white max-lg:rounded-[8px] max-lg:p-2">
            <p className="text-label text-[#A5A5A5]">Λήξη Συμβολαίου</p>
            <p className="text-body">{carInfo?.EndDate?.split('-')[2] + '/' +carInfo?.EndDate?.split('-')[1] + '/' + carInfo?.EndDate?.split('-')[0]}</p>
          </div>
        </div>
      )}
    </div>
  );
};
